module.exports = __webpack_public_path__ + "img/8.3c346bc4.png";